import axios from 'axios';

declare let booking_object: any;

export default class roomDate{ 

    // Private properties (rimangono invariate)
    private room_id: string;
    private modBookCalendar: any;
    private modTimeSlot: any;
    private modRoomGames: any;
    private el_time_slot: string;
    private el_players: string;
    private games_container_selector: string = '#games-container';

    /**
     * The constructor (rimane invariato)
     */
    constructor(options: any){
        
        this.room_id = options.roomId;
        this.modBookCalendar = options.calendarModule;
        this.modTimeSlot = options.timeSlotModule;
        this.modRoomGames = options.gamesModule;
        this.el_time_slot = options.timeSlotSelector;
        this.el_players = options.playersSelector;

    }

    /**
     * Sets up the event listener on the calendar.
     */
    initialize(){
        
        // Check if the calendar's picker element is available, as in your code.
        if(this.modBookCalendar && typeof this.modBookCalendar.pickerElement !== 'undefined'){

            this.modBookCalendar.pickerElement.addEventListener('click', (ev: MouseEvent) => {

                const element = ev.target as Element;

                // We only care about clicks on elements that are a day.
                if(!element?.matches('.day')){

                    return;

                }

                // A valid day was clicked.
                // We use a small delay (e.g., 50ms) to ensure the calendar's internal
                // state has updated before we call getDate(). This prevents race conditions.
                setTimeout(() => {
                    // Using an arrow function ensures 'this' correctly refers to our class instance.
                    this._handleDateChange();
                }, 50);

            });

        }

    }

    /**
     * This async function is triggered when the date changes. (rimane invariato)
     * @private
     */
    private async _handleDateChange(){
        
        // Get the date directly from the calendar module.
        const val_date_str = this.modBookCalendar.getDate('y-mm-dd');
        
        // It can happen that a click is registered but the date is not ready (e.g., month change).
        if(!val_date_str){
            
            return;

        }
        
        try{
            
            this.modRoomGames.showPreloader(this.games_container_selector);

            const newTimeSlotValue = await this.modTimeSlot.load(
                this.modBookCalendar,
                this.room_id
            );

            const playersElement: any = document.querySelector(this.el_players);
            const playersValue = playersElement ? playersElement.tomselect.getValue() : null;

            if(playersValue === null) {
                
                throw new Error("Could not read player count.");

            }

            const response = await this.modRoomGames.get(this.room_id, val_date_str, newTimeSlotValue, playersValue);
            
            this.modRoomGames.renderGames(response.data.data, this.games_container_selector);

        }catch (error){

            this.modRoomGames.showError(this.games_container_selector, 'Errore durante l\'aggiornamento dei giochi.');

        }

    }

}
